// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"493":"12c156df","585":"31c80f5c"}[chunkId] + ".js";
};